import ModalClass from "common/utils/ui/modal-class";
import { track } from "jiffy-analytics";

export default class ProductDetailsSampleOrderLimitModalClass extends ModalClass {
  constructor(modalSelector) {
    super({
      modalSelector
    });
  }

  get limitType() {
    return this.$modal?.dataset.limitType;
  }

  get $closeButtons() {
    return this.$modal?.querySelectorAll(".js-pdp-sample-order-limit-modal-close") || [];
  }

  get $continueShopping() {
    return this.$modal?.querySelector(".js-pdp-sample-order-limit-modal-continue-shopping");
  }

  get $goToCartLink() {
    return this.$modal?.querySelector(".js-pdp-sample-order-limit-modal-primary-action");
  }

  get trackingData() {
    const pdpData = window.document.pdpDynamicData || {};

    return {
      source: "sample_pdp",
      user_id: pdpData.user_hashed_id || null,
      made_sample_line_item_count: pdpData.made_sample_line_item_count || 0,
      user_sample_orders_count: pdpData.user_sample_orders_count || 0,
      limit_type: this.limitType
    };
  }

  trackButtonClick(target) {
    track("samples_limit_modal_clicked", {
      ...this.trackingData,
      target
    });
  }

  setModalVisibility(isVisible) {
    const $body = document.body;

    if (isVisible) {
      $body.classList.add("modal-open");
      this.$modal?.showModal();
    } else {
      $body.classList.remove("modal-open");
      this.$modal?.close();
    }
  }

  openModal() {
    if (!this.$modal) return this;

    const { limitType } = this;
    if (!limitType) return this;

    track("samples_limit_modal_opened", this.trackingData);
    this.setModalVisibility(true);
    this.isOpen = true;

    return this;
  }

  closeModal() {
    this.setModalVisibility(false);
    this.isOpen = false;

    return this;
  }

  initCloseHandlers() {
    if (!this.$modal) return;

    this.$closeButtons.forEach($button => {
      $button.addEventListener("click", () => {
        this.trackButtonClick("close");
        this.closeModal();
      });
    });
  }

  initActionButtonHandlers() {
    if (!this.$modal) return;

    // Continue shopping element (button or link)
    this.$continueShopping?.addEventListener("click", event => {
      this.trackButtonClick("continue_shopping");
      // If it's a link with href, handle navigation
      if (this.$continueShopping.tagName === "A" && this.$continueShopping.href) {
        event.preventDefault();
        this.closeModal();
        window.location.href = event.currentTarget.href;
      } else {
        // If it's a button, just close the modal
        this.closeModal();
      }
    });

    // Go to cart link (primary action)
    this.$goToCartLink?.addEventListener("click", event => {
      event.preventDefault();
      // Determine the target based on limit type
      const target =
        this.limitType === "sample_order_limit_reached" ? "order_history" : "go_to_cart";
      this.trackButtonClick(target);
      this.closeModal();
      window.location.href = event.currentTarget.href;
    });
  }

  init() {
    if (!this.$modal) return this;

    this.initCloseHandlers();
    this.initActionButtonHandlers();
    return this;
  }
}
